import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { isFetchingResult } from "@acto/taskpane/core/data-access/isFetchingResult";
import { MeetingPrepLearnedDefault } from "@acto/taskpane/core/domain";

const MeetingPrepLearnedDefaultsQuery = graphql(`
  query GetMeetingPrepLearnedDefaults {
    meetingPrepLearnedDefaults {
      id
      __typename
      cardKey
      learnedAfterHides
      suppressedAt
    }
  }
`);

export function useMeetingPrepLearnedDefaults(): DataAccessResult<MeetingPrepLearnedDefault> {
  const [result] = useQuery({ query: MeetingPrepLearnedDefaultsQuery });

  const { data, error } = result;
  const isFetching = isFetchingResult(result);
  const isPending = !data && isFetching;

  const learnedDefaults = useMemo(
    () => data?.meetingPrepLearnedDefaults.map(MeetingPrepLearnedDefault.fromGraphql),
    [data],
  );

  return {
    data: learnedDefaults,
    isFetching,
    isPending,
    error,
  };
}
